var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "x-date-picker" },
    [
      _c("flat-pickr", {
        ref: "datePickerWrap",
        attrs: { config: _vm.config },
        on: { "on-change": _vm.changed },
        model: {
          value: _vm.flatPickrModel,
          callback: function($$v) {
            _vm.flatPickrModel = $$v
          },
          expression: "flatPickrModel"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }